import PrescribedDaysPage from './PrescribedDaysPage';

export default PrescribedDaysPage;
